import React from 'react';
import cn from 'classnames';

const TemplateStatus = ({ templateActive }) => {
  return (
    <>
      <span
        className={cn('Pill Pill--dot mr-10', {
          'Pill--success': templateActive,
          'Pill--outline Pill--midnight': !templateActive,
        })}
      />
      {templateActive
        ? t('templates.status_toggle.active.name')
        : t('templates.status_toggle.draft.name')}
    </>
  );
};

export default TemplateStatus;
